import axios from 'axios';

import { baseUrl } from '#api/baseUrl';

export const postCurrenciesByAlliance = async value => {
  const { data } = await axios.post(`${baseUrl}/api/currencies-by-alliance/`, value);
  return data;
};
